import ApiConstant from './ApiContstant';
import DataService from './DataService';

class GetSettingsService {
    async getMySettings(id: any, email: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.GetMySettings, {
            Id: id,
            EmailAddress: email
        });
    }

    async SetSettings(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.SetMySettings, {
            ...data
        });
    }

    async GetSettingsBasic(id: any, email: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.GetMySettingsBasic, {
            Id: [id],
            EmailAddress: email
        });
    }

    async GetWorkLocation(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.GetWorklocation, {
            ...data
        });
    }

    async SetWorklocation(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.SetWorklocation, {
            ...data
        });
    }

    async SetAssignedSpaceAvailablity(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.SetAssignedSpaceAvailablity, {
            ...data
        });
    }
    async GetWorkPlacesList(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.GetWorkPlacesList, {
            ...data
        });
    }

    async GetTeamWorkPlaces(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.GetTeamWorkPlaces, {
            ...data
        });
    }

    async AssignedSpaceService(data: any) {
        return await DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.GetAssignedSpace, {
            ...data
        });
    }

    // async AssignedSpaceService(data: any) {
    //     return DataService.getData(localStorage.getItem('tenantUrl') + ApiConstant.GetAssignedSpace + data);
    // }
}

export default new GetSettingsService;
